export default {
  title: 'Time to split the pie!',
  number_of_shares: 'Number of Shares',
  description:
    'We advise you to choose a total amount of 120 shares at a minimum value of €0.01 each, as this is an easily divisible number among multiple shareholders. However, you can choose to deviate from this.',
  shareholders: 'Shareholders(s)',
  warning:
    'When incorporating a company with a high share capital, the notary is required to carry out additional work. For example, starting from a share capital of €10,000, the notary has a legal duty to investigate the origin of the funds. Because this involves a customized process, it is not possible to incorporate a B.V. via Ligo with a share capital higher than €10,000. For more information, feel free to contact us at 020-3031043.'
};
